<template>
  <div id="central" class="p-2">
    <div id="tab-wrapper">
      <TabComponent></TabComponent>
    </div>
    <div id="router-view-wrapper">
      <router-view @logout="(error) => $emit('logout', error)"></router-view>
    </div>
  </div>
</template>

<script>
import TabComponent from "./TabComponent";

export default {
  components: {
    TabComponent
  },
  emits: {
    logout: null
  },
  name: "Central.vue"
}
</script>

<style scoped>
@import "../../css/constants.css";
#central {
  background-color: white;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: var(--tab-height) 1fr;
  grid-template-areas: "tab-area" "router-area";
}

#tab-wrapper {
  grid-area: tab-area;
  overflow: hidden;
}

#router-view-wrapper {
  grid-area: router-area;
  overflow: auto;
}

</style>